import { IconFile } from './icons';

type Props = { name: string; size: string };

function MobileAttachment({ name, size }: Props) {
  return <button className="mobile-attachment" type="button" disabled title="当前附件记录未提供文件预览或下载地址">
    <span className="mobile-attachment__icon"><IconFile /></span>
    <span className="mobile-attachment__text"><strong title={name}>{name}</strong><small>{size}</small></span>
  </button>;
}

export default MobileAttachment;
